import { render } from "./HomeMedico.vue?vue&type=template&id=45b3c75a&scoped=true"
import script from "./HomeMedico.vue?vue&type=script&lang=js"
export * from "./HomeMedico.vue?vue&type=script&lang=js"

import "./HomeMedico.vue?vue&type=style&index=0&id=45b3c75a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b3c75a"]])

export default __exports__